import { DepartmentsView } from "@/features/departments/components/DepartmentsView"

export default function DepartmentsPage() {
  return <DepartmentsView />
}